document.addEventListener('DOMContentLoaded', () => {
    const dropdowns = document.querySelectorAll('.dropdown');

    dropdowns.forEach(dropdown => {
        dropdown.querySelectorAll('.dropdown-trigger').forEach(trigger => {
            trigger.addEventListener('click', (event) => {
                event.stopPropagation();
                dropdown.classList.toggle('is-active');
            });
        });

        const disabledDropdownItems = dropdown.querySelectorAll('.dropdown-item.is-disabled');

        disabledDropdownItems.forEach(item => {
            item.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();

                const popup = item.querySelector('.dropdown-item__popup');
                if (popup) {
                    popup.classList.add('is-active');

                    setTimeout(() => {
                        popup.classList.remove('is-active');
                    }, 2000);
                }
            });
        });
    });

    document.addEventListener('click', (event) => {
        const activeDropdowns = document.querySelectorAll('.dropdown.is-active');

        activeDropdowns.forEach(activeDropdown => {
            if (!activeDropdown.contains(event.target)) activeDropdown.classList.remove('is-active');
        });
    });
});
